import {
    QidModel,
    QidModelSafetyFunction,
    QidModelOption,
} from "server/models"
import {
    QidCalculationMethod,
    QidCalculationFormat,
} from "client/utils"
import { ResultDatapointListType } from "client/store"

export interface QidResultState {
    datapointList: ResultDatapointListType

    calculationMethod: QidCalculationMethod
    format: QidCalculationFormat
    decimal: number

    modelIds: number[]
    model: QidModel
    safetyFunction: QidModelSafetyFunction
    option: QidModelOption

    expandedModelIds: readonly number[]
    expandedSafetyFunctionIds: readonly number[]
    expandedOptionIds: readonly number[]
}

export const QID_RESULT_DATAPOINT_LIST = "QID_RESULT_DATAPOINT_LIST"

export const QID_RESULT_CALCULATION_METHOD = "QID_RESULT_CALCULATION_METHOD"
export const QID_RESULT_FORMAT = "QID_RESULT_FORMAT"
export const QID_RESULT_DECIMAL = "QID_RESULT_DECIMAL"

export const QID_RESULT_MODEL_IDS = "QID_RESULT_MODEL_IDS"
export const QID_RESULT_MODEL = "QID_RESULT_MODEL"
export const QID_RESULT_SAFETY_FUNCTION = "QID_RESULT_SAFETY_FUNCTION"
export const QID_RESULT_OPTION = "QID_RESULT_OPTION"

export const QID_RESULT_EXPANDED_MODEL_IDS = "QID_RESULT_EXPANDED_MODEL_IDS"
export const QID_RESULT_EXPANDED_SAFETY_FUNCTION_IDS = "QID_RESULT_EXPANDED_SAFETY_FUNCTION_IDS"
export const QID_RESULT_EXPANDED_OPTION_IDS = "QID_RESULT_EXPANDED_OPTION_IDS"
